import { render, staticRenderFns } from "./cly-remover.vue?vue&type=template&id=edf767f8"
import script from "./cly-remover.vue?vue&type=script&lang=js"
export * from "./cly-remover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports